import { api } from './api';
import { selectors } from './selectors';
import { slice } from './slice';

interface IManageDeviceGroupsStore {
  actions: typeof slice.actions;
  selectors: typeof selectors;
  api: typeof api;
}

const manageDeviceGroupsStore: IManageDeviceGroupsStore = {
  actions: slice.actions,
  selectors,
  api,
};

export { manageDeviceGroupsStore };
